import axios from "../axiosInstance";

class EcovadisService{
    async getEcovadisStatus(){
        return await axios.get("Ecovadis");
    }
}

export default new EcovadisService();